module.exports = __webpack_public_path__ + "img/ergo-essential1.11e0343b.png";